// extracted by mini-css-extract-plugin
module.exports = {"feedActionsSection":"_1NFGO8Pp","newFeedButton":"fugj6Qke","feedsTableSearchBar":"_2DWCBeLv"};